import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");

const container =
  document.getElementById("info-lapak-root") || document.getElementById("root");

if (container) {
  createRoot(container).render(
    <StrictMode>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="id">
        <App />
      </LocalizationProvider>
    </StrictMode>,
  );
}
